import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetSectionQuery, useUpdateSectionMutation, EnumSectionKind } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'section-content',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useUpdateSectionMuta = useUpdateSectionMutation(),
      updateSection = _useUpdateSectionMuta.mutate,
      onDone = _useUpdateSectionMuta.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var disabledSave = ref(false);
    var _useGetSectionQuery = useGetSectionQuery({
        id: props.id
      }, computed(function () {
        return {
          enabled: !!props.id
        };
      })),
      sectionResult = _useGetSectionQuery.result,
      loading = _useGetSectionQuery.loading,
      refetch = _useGetSectionQuery.refetch;
    var section = computed(function () {
      var _sectionResult$value;
      return (_sectionResult$value = sectionResult.value) === null || _sectionResult$value === void 0 ? void 0 : _sectionResult$value.getSection;
    });
    var sectionId = computed(function () {
      return section.value && section.value.id != null ? section.value.id : null;
    });
    var sectionLabel = computed(function () {
      return section.value && section.value.label ? section.value.label : '';
    });
    var sectionLabelI18n = computed(function () {
      return section.value && section.value.labelI18n ? section.value.labelI18n : null;
    });
    var sectionSort = computed(function () {
      return section.value && section.value.sort != null ? section.value.sort : '';
    });
    var sublabelEn = computed(function () {
      var s = section.value;
      return s && s.sublabelI18n && s.sublabelI18n['en'] != null ? s.sublabelI18n['en'] : '';
    });
    var sectionSublabelI18n = computed(function () {
      return section.value && section.value.sublabelI18n ? section.value.sublabelI18n : null;
    });
    var hasChildSections = computed(function () {
      return !!(section.value && section.value.sections && section.value.sections.length);
    });
    var sectionChildrenSummary = computed(function () {
      var s = section.value;
      return s && s.sections && s.sections.length ? s.sections.map(function (sec) {
        return "".concat(sec.label, " (").concat(sec.id, ")");
      }).join(', ') : '';
    });
    var sectionKind = computed(function () {
      return section.value && section.value.sectionKind ? section.value.sectionKind : null;
    });
    var parentLabel = computed(function () {
      var s = section.value;
      return s && s.parent && s.parent.label ? s.parent.label : 'No parent selected';
    });
    var taxonomyLabel = computed(function () {
      var s = section.value;
      return s && s.taxonomy && s.taxonomy.label ? s.taxonomy.label : 'No taxonomy selected';
    });
    var sectionTaxonomyId = computed(function () {
      return section.value && section.value.taxonomyId != null ? section.value.taxonomyId : null;
    });
    var sectionKindOptions = [{
      text: 'Question',
      value: EnumSectionKind.Question
    }, {
      text: 'Metric',
      value: EnumSectionKind.Metric
    }, {
      text: 'IRO',
      value: EnumSectionKind.Iro
    }, {
      text: 'Account',
      value: EnumSectionKind.Account
    }];
    return {
      __sfc: true,
      updateSection: updateSection,
      onDone: onDone,
      props: props,
      disabledSave: disabledSave,
      sectionResult: sectionResult,
      loading: loading,
      refetch: refetch,
      section: section,
      sectionId: sectionId,
      sectionLabel: sectionLabel,
      sectionLabelI18n: sectionLabelI18n,
      sectionSort: sectionSort,
      sublabelEn: sublabelEn,
      sectionSublabelI18n: sectionSublabelI18n,
      hasChildSections: hasChildSections,
      sectionChildrenSummary: sectionChildrenSummary,
      sectionKind: sectionKind,
      parentLabel: parentLabel,
      taxonomyLabel: taxonomyLabel,
      sectionTaxonomyId: sectionTaxonomyId,
      sectionKindOptions: sectionKindOptions
    };
  }
});